import React from 'react';
import { Grid } from '@mui/material';

import { useCCTableContext } from '../cc-table.context';
import { DefaultCard } from '../cc-table-cards';

export const CCTableContent = () => {
  const { columns, paginatedRows } = useCCTableContext();

  return (
    <Grid container spacing={2}>
      {paginatedRows.map((row, index) => {
        return (
          <Grid item xs={12} key={`cc-table-row-${index}`}>
            <DefaultCard columns={columns} row={row} />
          </Grid>
        );
      })}
    </Grid>
  );
};
